// src/pages/CircleRedirectPage.js
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';

const CircleRedirectPage = () => {
  const { shortCode } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOriginalUrl = async () => {
      try {
        const response = await fetch(`/api/circles/share/${shortCode}`);
        if (!response.ok) throw new Error('Invalid or expired link');
        
        const data = await response.json();
        navigate(`/circle/${data.circleId}`, { 
          state: { 
            circleId: data.circleId,
            fromShortLink: true 
          }
        });
      } catch (err) {
        setError(err.message);
      }
    };

    fetchOriginalUrl();
  }, [shortCode, navigate]);

  if (error) {
    return (
      <Box 
        display="flex" 
        flexDirection="column" 
        alignItems="center" 
        justifyContent="center" 
        minHeight="100vh"
      >
        <Typography color="error" variant="h6">
          {error}
        </Typography>
      </Box>
    );
  }

  return (
    <Box 
      display="flex" 
      alignItems="center" 
      justifyContent="center" 
      minHeight="100vh"
    >
      <CircularProgress />
    </Box>
  );
};

export default CircleRedirectPage;